import type { NDateLocale } from './enUS'
import { enIN } from 'date-fns/locale'

const dateMrIN: NDateLocale = {
  name: 'mr-IN',
  locale: enIN
}

export default dateMrIN
